import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId70967: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/EMEA_Autumn_Switzerland_1400x600.jpg",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/DK.HPR.012021.pdf",
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    driveAgeCheckbox: true,
    includeGT: false,
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
